// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#instructor-table-dynamic[data-v-646fb303]{width:100%;padding:0 36px}.el-badge.item[data-v-646fb303]{margin-top:10px}.el-badge.item .v-avatar[data-v-646fb303]{margin-left:8px}", ""]);
// Exports
module.exports = exports;
